import React from 'react';

/*** changes to this file need to be reflected in legacyOOBAModal.pug ***/
const OOBAModal = () => {
	return (
		<div className="cb-modal cb-fade" id="oobaModal" data-toggle="cb-modal" data-backdrop="static">
			<div className="cb-modal-dialog" role="document" id="ooba-processing-content">
				<div className="cb-modal-content">
					<div className="cb-modal-header">
						<h2 id='security-verbiage' className="cb-modal-title">Your request is processing...</h2>
					</div>
				</div>
			</div>
			<div className="cb-modal-dialog cb-hide" id="ooba-push-content" role="document">
				<div className="cb-modal-content">
					<div style={{
						display: 'flex',
						background: '#e6f2f6',
						width: 120,
						height: 120,
						borderRadius: 100,
						margin: '30px auto 0px',
					}}>
						<span id="push-number" style={{
							color: '#087193',
							margin: 'auto',
							fontFamily: 'Poppins',
							fontWeight: 600,
							fontSize: 40,
						}}></span>
					</div>
					<div className="cb-modal-header" style={{marginTop: 15}}>
						<h2 id="request-sent-header" className="cb-modal-title" style={{color: '#43454d', fontWeight: 600 }}>Request Sent</h2>
					</div>
					<div className="cb-modal-body">
						<p style={{
							margin: '10px 0px 30px',
							fontSize: '16px',
							fontWeight: 400,
							color: '#43454d',
						}}>A request was sent to your mobile device. Open the app and select the number that matches the one shown on this screen.</p>
					</div>
				</div>
			</div>
			{/* scuffed font pre-loading*/}
			<span style={{opacity: 0, fontFamily: 'Poppins, sans-serif', fontWeight: 600}}></span>
			<span style={{opacity: 0, fontFamily: '"Open Sans", sans-serif', fontWeight: 600}}></span>
		</div>
	)
};

export default OOBAModal
